<template>
    <div class="cw-right-center">
        <section class="center-links">
            <header class="title">
                <span class="title-f">常用链接</span>
            </header>
            <footer class="links-content">
                <p @click="handleWindowOpen('http://rsj.beijing.gov.cn')">人社局网站</p>
                <p @click="handleWindowOpen('http://gjj.beijing.gov.cn')">公积金管理中心</p>
                <p @click="handleWindowOpen('http://beijing.chinatax.gov.cn')">税务局网站</p>
            </footer>
        </section>
        <section class="center-advisory">
            <header class="title">
                <span class="title-f">咨询中心</span>
            </header>
            <footer class="advisory-content">
                <div class="advisory-content-item" @click="handleOpenEasemob">
                    <span>
                        <img src="@/assets/webImg/admin/workbench_zhixun1.png" alt="">
                    </span>
                    <p>售前顾问</p>
                </div>
                <div class="advisory-content-item" @click="handleOpenEasemob">
                    <span>
                        <img src="@/assets/webImg/admin/workbench_zhixun2.png" alt="">
                    </span>
                    <p>客户咨询</p>
                </div>
            </footer>
        </section>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {

    data() {
        return {

        }
    },

    computed: {
        ...mapGetters(['userInfo']),
    },

    methods:{
        /**
         * @description 打开客服
         */
        handleOpenEasemob() {
            let userInfo = this.userInfo
            window.easemobim = window.easemobim || {}
            easemobim.config = {
                configId: '982d8f2d-06db-49ab-9e14-673c151172b6',
                visitor: {         
                    trueName: userInfo.cusName,
                    // qq: '567**34',
                    // phone: '188****8888',
                    // companyName: '环信',
                    // userNickname: '我是黎小冷',
                    // description: '描述信息',
                    // email: '123456@**.com',
                    // tags:[  
                        //     'vip1',
                    //     'vip2'
                    // ]
                }
            }

            window.easemobim.bind()
        },

        handleWindowOpen(url) {
            window.open(url); 
        }
    }
}

</script>

<style lang="scss" scoped>
.cw-right-center {
    padding: 0 14px 14px 14px;
    display: flex;
    .title {
        margin-bottom: 9px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title-f {
            font-size: 18px;
            font-weight: 600;
            color: #333333;
            &::before {
                content: '';
                display: inline-block;
                width: 6px;
                height: 6px;
                margin-right: 10px;
                margin-bottom: 3px;
                border-radius: 100%;
                background: #84D9D5;
            }
        }
    }

    /** 常用链接 */
    .center-links {
        margin-right: 10px;
        .links-content {
            width: 168px;
            height: 101px;
            padding-top: 14px;
            padding-left: 15px;
            background: #FFFFFF;
            box-shadow: 0px 0px 4px 0px rgba(165,165,165,0.36);
            border-radius: 7px;
            p {
                margin-bottom: 14px;
                font-size: 13px;
                color: #1A84FA;
                cursor: pointer;
                text-decoration: underline;
            }
            p::before {
                content: '·';
                display: inline-block;
                margin-right: 6px;
                text-decoration: none;
            }
        }
    }

    /** 咨询中心 */
    .center-advisory {
        width: 240px;
        .advisory-content {
            display: inline-flex;
            justify-content: space-between;
            width: 100%;
        }
        .advisory-content-item {
            width: 85px;
            height: 115px;
            background: #FFFFFF;
            box-shadow: 0px 0px 4px 0px rgba(165,165,165,0.36);
            border-radius: 7px;
            text-align: center;
            span {
                margin-top: 16px;
                display: block;
                text-align: center;
                height: 49px;
                img { height: 100%; }
            }
            p {
                margin-top: 13px;
                font-size: 13px;
                font-weight: 500;
                color: #999999;
            }
        }
    }

    
}
</style>
